import { createContext } from 'react';

export type TDropdownAnalyticsSendData = { lineTitle?: string; seriesTitle?: string; modelsTitle?: string; modelsId?: string };

export type TDropdownContextSendData = TDropdownAnalyticsSendData & {
  id: number;
  line?: string;
  series?: string;
  models?: string;
};

export type TMultipleDropdownContextSendData = {
  value: TDropdownContextSendData[];
};

export type TContextData = TMultipleDropdownContextSendData & {
  updateSendData: (index: number, newSendData: Partial<TDropdownContextSendData>) => any;
  isLineHidden?: boolean;
  isSeriesHidden?: boolean;
};

const MultiDropdownSendData = createContext<TContextData>({
  value: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateSendData: () => {},
});

export { MultiDropdownSendData };
